/**
 * Shared Required Field Validation
 * Helper schemas for required fields
 */

import { z } from "zod";

/**
 * Required string schema
 * - Must not be empty
 * - Trims whitespace before validation
 */
export const requiredString = (fieldName = "This field") =>
  z
    .string()
    .min(1, `${fieldName} is required`)
    .transform((val) => val.trim());

/**
 * Required string schema without trim
 */
export const requiredStringNoTrim = (fieldName = "This field") =>
  z.string().min(1, `${fieldName} is required`);

/**
 * Optional string schema
 * - Allows empty string, null, or undefined
 * - Trims whitespace if provided
 */
export const optionalString = z
  .string()
  .optional()
  .nullable()
  .transform((val) => val?.trim() || null);

/**
 * Required number schema
 */
export const requiredNumber = (fieldName = "This field") =>
  z.number({
    error: `${fieldName} must be a number`,
  });

/**
 * Optional number schema
 */
export const optionalNumber = z.number().optional().nullable();
